'use strict';

var React = require('react');
var appTypes = require('../../types/appTypes');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');
var mouseHelper = require('../../helper/mouseHelper');

/**
 * 水平滑块
 */
var HSlider2 = React.createClass({
  getInitialState: function () {
    return {
      progress: styleHelper.getInt(this.props, propConst.PROGRESS)
    };
  },
  render: function () {
    var trackStyle;
    var sliderStyle;
    var sliderClass = 'slide';
    var sliderWidth;
    var sliderContentStyle;
    var boxStyle;

    var isDisabled = this.getIsDisabled();
    var sliderColor = isDisabled ? '#DDD' : this.props.sliderColor;
    switch (this.props.sliderShapeType) {
    case 'SCircle':
      sliderClass += ' circle';
      sliderWidth = 15;
      sliderContentStyle = {
        backgroundColor: sliderColor
      };
      break;
    case 'SSquare':
      sliderClass += ' square';
      sliderWidth = 15;
      sliderContentStyle = {
        backgroundColor: sliderColor
      };
      break;
    default:
      sliderClass += ' incisive';
      sliderWidth = 8;
      sliderContentStyle = {
        borderBottomColor: sliderColor
      };
      break;
    }
    var progress = this.state.progress;
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);

    var test = this.props;

    trackStyle = {
      top: (h - 2) / 2,
      backgroundColor: isDisabled ? '#DDD' : this.props.trackColor
    };

    sliderStyle = {
      left: Math.min((progress / 100) * w, w - sliderWidth)
    };

    boxStyle = {
      height: h
    };

    return (<div style={boxStyle} onClick={this.onTrackClick}>
      <div style={trackStyle} className="track"></div>
      <div onMouseDown={this.onDrag}
           onTouchStart={this.onDrag}
           onClick={this.onSliderClick}
           style={sliderStyle} className={sliderClass}>
        <div className="slide-shape" style={sliderContentStyle}></div>
      </div>
    </div>)
  },
  getIsDisabled: function () {
    var state = styleHelper.getPropertyValue(this.props, propConst.STATUS);
    if (!state) {
      state = this.props[propConst.STATE];
    }
    return state === appTypes.ComStatus2.DISABLE;
  },
  onSliderClick: function (e) {
    e.stopPropagation();
  },
  onDrag: function (e) {
    if (this.getIsDisabled()) {
      return;
    }
    var width = parseInt(this.props.w, 10);
    var self = this;
    var progress = this.state.progress;
    var unit = width / 100;
    mouseHelper.dragDelegate(function (e, delta) {
      self.setState({
        progress: Math.max(0, Math.min(delta.x / unit + progress, 100))
      });
      e.stopPropagation();
      e.preventDefault();
    }, function (e) {
      e.stopPropagation();
      e.preventDefault();
    });
    e.stopPropagation();
    e.preventDefault();
  },
  onTrackClick: function (e) {
    var parent = e.target.parentNode;
    var parentRects = parent.getBoundingClientRect();
    var offsetLeft = e.clientX - parentRects.left;
    var width = parseInt(this.props.w, 10);
    this.setState({
      progress: offsetLeft / width * 100
    });
  }
});

module.exports = HSlider2;



// WEBPACK FOOTER //
// ./src/views/Components/HSlider2.jsx